import { Button, Link } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';
import { logout } from 'features/auth/store/authSlice';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import '../assets/styles/ErrorPage.css';

const ErrorHandler = ({ error, info, clearError }) => {
  const [showErrorDetail, setShowErrorDetail] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleHardReload = () => {
    dispatch(logout());
    navigate('/login', { replace: true });
    clearError();
  };

  return (
    <div className="error-container">
      <div className="error-div">
        <SentimentVeryDissatisfiedIcon className="sad-face-icon" />
        <h1>Oops!</h1>
        <h2>Something went wrong</h2>
        <p>
          Sorry for the inconvenience caused but we can't get the information right now. Please try
          again later.
        </p>
        <div>
          <p className="more-info" onClick={() => setShowErrorDetail(!showErrorDetail)}>
            More Information...
          </p>
          {showErrorDetail && error ? (
            <>
              <p style={{ marginLeft: '20px' }}>{error?.message}</p>
              <p style={{ marginLeft: '20px' }}>
                {info?.componentStack ? info?.componentStack : info}
              </p>
            </>
          ) : (
            <p style={{ whiteSpace: 'pre' }}> </p>
          )}
        </div>
        <div>
          <ArrowBackIcon style={{ color: '#1eb980', verticalAlign: 'middle' }} />
          <a href="/">Homepage</a>
        </div>

        <Link component={Button} className="more-info" onClick={handleHardReload}>
          Clear cache and sign in again?
        </Link>
      </div>
    </div>
  );
};

export default ErrorHandler;
